"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DefaultRenderer_1 = tslib_1.__importDefault(require("../renderers/DefaultRenderer"));
const TDCssClasses_1 = tslib_1.__importStar(require("../TDCssClasses"));
class ColumnConfig {
    constructor(...args) {
        this.styles = [];
        const { heading, headerStyle, mapDataToTD, mapDataToTDCssClasses, mapDataToSortValue, bolded = false, wordWrap = TDCssClasses_1.TDWordWrap.DEFAULT, sortable = true, clickable = false, canFilter, footers } = this.extractColumnConfigArgs(args);
        this.heading = heading;
        this.headerStyle = headerStyle;
        this.mapDataToTD = mapDataToTD;
        this.mapDataToTDCssClasses = mapDataToTDCssClasses;
        this.mapDataToSortValue = mapDataToSortValue;
        this.bolded = bolded;
        this.wordWrap = wordWrap;
        this.sortable = sortable;
        this.clickable = clickable;
        this.canFilter = canFilter;
        this.footers = footers;
        this.renderer = new DefaultRenderer_1.default();
    }
    getData(data) {
        return this.mapDataToTD(data);
    }
    getTDCssClasses(data) {
        const tdCssClasses = this.mapDataToTDCssClasses?.(data) || [];
        if (this.bolded) {
            tdCssClasses.push(TDCssClasses_1.default.BOLDED);
        }
        if (this.wordWrap) {
            tdCssClasses.push(this.wordWrap);
        }
        return tdCssClasses;
    }
    getSortableData(data) {
        return this.mapDataToSortValue?.(data) ?? this.mapDataToTD(data);
    }
    /**
     * The number of columns this row should span. If this method returns 0 the column will not be rendered.
     *
     * @return
     */
    getColSpan() {
        return 1;
    }
    extractColumnConfigArgs(args) {
        // If there is more than one argument, then it's the old ColumnConfig initialisation
        if (args.length > 1) {
            const [heading, headerStyle, mapDataToTD, sortable, clickable, footers] = args;
            return {
                clickable,
                footers,
                headerStyle,
                heading,
                mapDataToTD,
                sortable
            };
        }
        return args[0];
    }
}
exports.default = ColumnConfig;
//# sourceMappingURL=ColumnConfig.js.map